import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SortDirection } from '@angular/material/sort';

export interface DataTableSortState {
  column: string;
  direction: SortDirection;
}

@Directive({ selector: '[ngVar]', exportAs: 'ngVar' })
export class NgVarDirective {
  @Input()
  set ngVar(context: any) {
    this.context.$implicit = this.context.ngVar = context;
    this.updateView();
  }

  context: any = {};

  constructor(private vcRef: ViewContainerRef, private templateRef: TemplateRef<any>) {}

  updateView() {
    this.vcRef.clear();
    this.vcRef.createEmbeddedView(this.templateRef, this.context);
  }
}
